import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";

import css from "./AdminPage.module.css";
import { newId } from "../../utils/newId";
import { Input } from "../../components/common/Input";
import { InputArea } from "../../components/common/InputArea";
import { DataContext } from "../../context/DataContext";
import { storage } from "../../services/firebaseConfig";
import { createActsListFirebase } from "../../services/firebaseService";
import dayjs from "dayjs";
import { Head } from "../../utils/Head";

export const NewAct = () => {
  const {
    mindList,
    setMindList,
    moveList,
    setMoveList,
    nutriList,
    setNutriList,
    valuesList,
    setValuesList,
  } = useContext(DataContext);
  const navigate = useNavigate();
  const [state, setState] = useState("");
  const [axis, setAxis] = useState("");
  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");
  const [image, setImage] = useState("");
  const [content, setContent] = useState("");
  const [imageUpload, setImageUpload] = React.useState(null);
  const [progress, setProgress] = React.useState(null);

  function handleSubmit() {
    let updatedActsList = [];

    const newPost = {
      id: newId(),
      createdAt: Date.now(),
      updatedAt: Date.now(),
      axis: axis,
      title: title,
      url: url,
      image: image ? image : "",
      content: content ? content : "",
    };

    if (axis === "nutri" && nutriList) {
      updatedActsList = [...nutriList];
      updatedActsList.push(newPost);
      setNutriList(updatedActsList);
      createActsListFirebase("nutri", updatedActsList);
    } else if (axis === "mind" && mindList) {
      updatedActsList = [...mindList];
      updatedActsList.push(newPost);
      setMindList(updatedActsList);
      createActsListFirebase("mind", updatedActsList);
    } else if (axis === "move" && moveList) {
      updatedActsList = [...moveList];
      updatedActsList.push(newPost);
      setMoveList(updatedActsList);
      createActsListFirebase("move", updatedActsList);
    } else if (axis === "family" || "career" || "fun") {
      updatedActsList = [...valuesList];
      updatedActsList.push(newPost);
      setValuesList(updatedActsList);
      createActsListFirebase("values", updatedActsList);
    }

    alert("act created");
    navigate("/admin");
  }

  const uploadImage = () => {
    const name = newId();
    let imageRef = ref(storage, `postImages/${state.axis}/theory/${name}`);

    const uploadTask = uploadBytesResumable(imageRef, imageUpload);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress(progress);
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
          default:
            break;
        }
      },
      (error) => {
        console.log(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          console.log(downloadURL);
          setImage(downloadURL);
          alert("Image Uploaded");
        });
      }
    );
  };

  return (
    <div className={css.container}>
      <Head title="Admin" description={"Admin - Ibhava"} />
      <h4>New Act</h4>
      <p>Date: {dayjs().format("DD/MM/YY")}</p>
      <p>axis:</p>
      <div>
        <label className={css.axis}>
          mind
          <input
            type="checkbox"
            checked={axis === "mind" ? true : false}
            onChange={() => {
              setAxis("mind");
            }}
          />
          <span className={css.checkmark}></span>
        </label>
        <label className={css.axis}>
          move
          <input
            type="checkbox"
            checked={axis === "move" ? true : false}
            onChange={() => {
              setAxis("move");
            }}
          />
          <span className={css.checkmark}></span>
        </label>
        <label className={css.axis}>
          nutri
          <input
            type="checkbox"
            checked={axis === "nutri" ? true : false}
            onChange={() => {
              setAxis("nutri");
            }}
          />
          <span className={css.checkmark}></span>
        </label>
        <label className={css.axis}>
          family
          <input
            type="checkbox"
            checked={axis === "family" ? true : false}
            onChange={() => setAxis("family")}
          />
          <span className={css.checkmark}></span>
        </label>
        <label className={css.axis}>
          career
          <input
            type="checkbox"
            checked={axis === "career" ? true : false}
            onChange={() => setAxis("career")}
          />
          <span className={css.checkmark}></span>
        </label>
        <label className={css.axis}>
          fun
          <input
            type="checkbox"
            checked={axis === "fun" ? true : false}
            onChange={() => setAxis("fun")}
          />
          <span className={css.checkmark}></span>
        </label>
      </div>
      <Input
        type="text"
        name="title"
        placeholder="Title"
        label="Title"
        value={title}
        required
        className={css.inputText}
        onChange={(e) => {
          setTitle(e.target.value);
        }}
        autoComplete="off"
      />
      <Input
        type="text"
        name="url"
        placeholder="url"
        label="url"
        value={url}
        required
        className={css.inputText}
        onChange={(e) => setUrl(e.target.value)}
        autoComplete="off"
      />
      {image && <img alt="" src={image} className={css.image} />}
      <div>
        <input
          type="file"
          onChange={(event) => {
            setImageUpload(event.target.files[0]);
          }}
        />
        <button
          onClick={(e) => {
            e.preventDefault();
            uploadImage();
          }}
          disabled={progress !== null && progress < 100}
        >
          Upload Image
        </button>
      </div>
      <InputArea
        type="text"
        name="content"
        placeholder="Content"
        label="Content"
        value={content}
        required
        className={css.inputText}
        onChange={(e) => setContent(e.target.value)}
        autoComplete="off"
      />
      <div className={css.footer} onClick={() => handleSubmit()}>
        <button className="saveButton">Save</button>
      </div>
    </div>
  );
};
